export enum IntegrationServices {
  HUBSPOT = 'hubspot',
  MARKETO = 'marketo',
  ZAPIER = 'zapier',
  SALESFORCE = 'salesforce',
  MS_DYNAMICS_SALES = 'ms_dynamics_sales',
  OUTLOOK = 'outlook',
  PIPEDRIVE = 'pipedrive',
  ZOHO_CRM = 'zoho_crm',
  CHILI_PIPER = 'chili_piper',
  GOHIGHLEVEL = 'gohighlevel',
  MONDAY = 'monday',
}
